module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [(!_vm.data.success) ? _c('div', {
    staticClass: "pass-forgot-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Przypomnij hasło")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Podaj adres e-mail, którego uzyłeś do rejestracji."), _c('br'), _vm._v("\n      Wyślemy do Ciebie wiadomość z linkiem umożliwiającym ustawienie nowego hasła.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Wprowadź e-mail użyty przy rejestracji:")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Użytkownik o podanym adresie e-mail nie istnieje")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true",
      "errors": _vm.data.errors['email']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['email'] = val; }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Przypomnij hasło")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), (_vm.data.success) ? _c('div', {
    staticClass: "pass-forgot-page center-align"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/send_email.png"),
      "alt": "email wysłany"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Sprawdź skrzynkę")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle"
  }, [_vm._v("\n      Nowe hasło zostało wysłane na podany przez Ciebie adres e-mail.\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_c('i', {
    staticClass: "mfind-icon-back left"
  }), _vm._v("\n        Wróć do logowania\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626666a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/passForgot.vue
// module id = 384
// module chunks = 0